import { createContext } from "react";

const CartContext = createContext({});

export const CartProvider = CartContext.Provider;

export default CartContext;
